export enum NotificationStatus {
  Sent = "SENT",
  Draft = "DRAFT",
  InProgress = "IN_PROGRESS",
  Scheduled = "SCHEDULED",
}
